import {
  AppBar,
  Box,
  Button,
  Card,
  Grid,
  makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import './Evaluator.css';
import { useHistory, useLocation } from 'react-router-dom';
import { getEvaluation, getInvigilationData } from '../../../Utils/apiServices';
import EvaluationSetup from './EvalutionSetup';
import routes from '../../../Utils/routes.json';
import KenLoader from '../../../Components/KenLoader';
import BreadCrumb from '../../../Components/BreadCrumb';
import moment from 'moment';

const arrayBreadCrumb = [
  // {
  //   head: 'Exam',
  //   url: routes.ExamSetup,
  // },
  {
    head: 'Evaluation',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    marginTop: '30px',
    color: theme.palette.KenColors.primary,
  },
  typoTitle: {
    fontSize: 14,
    fontWeight: 400,
    opacity: '0.5',
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  card: {
    marginTop: '30px',
    padding: '20px',
    background: '#FEFEFE',
    borderRadius: '8px',
  },
  Rejected: {
    background: 'rgba(232, 18, 0, 0.27)',
    padding: '10px',
    borderRadius: '4px',
    width: '100px',
    fontSize: '12px',
    textAlign: 'center',
  },
  Accepted: {
    background: '#D0EED2',
    padding: '10px',
    borderRadius: '4px',
    width: '100px',
    fontSize: '12px',
    textAlign: 'center',
  },
  Pending: {
    background: 'rgba(255, 239, 182, 0.27)',
    padding: '10px',
    borderRadius: '4px',
    width: '100px',
    fontSize: '12px',
    textAlign: 'center',
  },
}));

const EvaluatorTable = (props) => {
  console.log(props);
  const location = useLocation();
  console.log(location);
  const classes = useStyles();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [resetAPI, setResetAPI] = useState(true);
  const [loader, setLoader] = useState(false);
  const [deadLine, setDeadLine] = useState('');

  useEffect(() => {
    setLoader(true);
    getEvaluation(location?.state?.data?.Id)
      .then((res) => {
        if (res?.data?.length > 0) {
          const data = res?.data?.map((el, index) => {
            return {
              id: index,
              room: el?.Name,
              name: el?.contcatName,
              age: el?.contcatRole,
              email: el?.contactEmail,
              section: el?.section,
              courseOfferingId: el?.courseOfferingId,
              popUp: el?.status,
              status: (
                <div
                  style={{
                    fontSize: '12px',
                    fontWeight: 400,
                    background: '#52C15A45',
                    padding: '10px',
                    width: '90px',
                  }}
                >
                  {el?.status}
                </div>
              ),
              Reason: el?.reason,
              ...el,
            };
          });
          setLoader(false);
          setData(data);
        } else {
          setData([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [resetAPI]);

  function addDaysToDate(dateString, daysToAdd) {
    const date = moment(dateString, 'YYYY-MM-DD');
    date.add(daysToAdd, 'days');
    return date.format('DD-MM-YYYY');
  }

  useEffect(() => {
    const date = location?.state?.data?.Exam_Date;
    const daysToAdd = 15;
    const resultDate = addDaysToDate(date, daysToAdd);
    setDeadLine(resultDate);
  }, [location]);

  return (
    <div>
      {loader && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Evaluation
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Box>
              {location?.state?.backBtn ? (
                <Button
                  variant="outlined"
                  color="primary"
                  style={{
                    background: '#08466F',
                    color: '#ffff',
                    textTransform: 'inherit',
                    borderRadius: '6px',
                  }}
                  onClick={() => {
                    history.goBack();
                    history.push({
                      pathname: `${routes.evaluation}`,
                      state: {
                        handleReload: true,
                      },
                    });
                  }}
                >
                  Back
                </Button>
              ) : null}
            </Box>
          </Grid>
        </Toolbar>
      </AppBar>
      <div className={classes.card}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4} sm={6}>
            <div>
              <Grid container>
                <Grid item xs={5}>
                  <div className={classes.typoTitle}> Program :</div>
                </Grid>
                <Grid item xs={7}>
                  <div className={classes.typoDescription}>
                    {location?.state?.program}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <div>
              <Grid container>
                <Grid item xs={5}>
                  <div className={classes.typoTitle}> Batch :</div>
                </Grid>
                <Grid item xs={7}>
                  <div className={classes.typoDescription}>
                    {location?.state?.batch}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <div>
              <Grid container>
                <Grid item xs={5}>
                  <div className={classes.typoTitle}> Term :</div>
                </Grid>
                <Grid item xs={7}>
                  <div className={classes.typoDescription}>
                    {location?.state?.term}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <div>
              <Grid container>
                <Grid item xs={5}>
                  <div className={classes.typoTitle}> Course :</div>
                </Grid>
                <Grid item xs={7}>
                  <div className={classes.typoDescription}>
                    {location?.state?.data?.Course}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <div>
              <Grid container>
                <Grid item xs={5}>
                  <div className={classes.typoTitle}> Exam :</div>
                </Grid>
                <Grid item xs={7}>
                  <div className={classes.typoDescription}>
                    {location?.state?.data?.Exam_Name__c}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <div>
              <Grid container>
                <Grid item xs={5}>
                  <div className={classes.typoTitle}> Type :</div>
                </Grid>
                <Grid item xs={7}>
                  <div className={classes.typoDescription}>
                    {location?.state?.data?.Exam_Type__c}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <div>
              <Grid container>
                <Grid item xs={5}>
                  <div className={classes.typoTitle}>Exam Date :</div>
                </Grid>
                <Grid item xs={7}>
                  <div className={classes.typoDescription}>
                    {location?.state?.data?.Exam_Date}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <div>
              <Grid container>
                <Grid item xs={5}>
                  <div className={classes.typoTitle}>Deadline :</div>
                </Grid>
                <Grid item xs={7}>
                  <div className={classes.typoDescription}>{deadLine}</div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
      <EvaluationSetup
        data={data}
        setData={setData}
        setResetAPI={setResetAPI}
        resetAPI={resetAPI}
        examData={location?.state}
      />
    </div>
  );
};

export default EvaluatorTable;
